.ui.dropdown {
    .text {
      line-height: 1.2;
    }
    .menu .item  {
      line-height: 1.2 !important;
    }
  }
  .ui.selection.dropdown  > .text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .ui.selection.dropdown:not(.multiple) > .text {
    width: 100%;
  }
